import { useQuery } from "@tanstack/react-query";
import API from "@/api";

function useRacks(nurseryId: string, tankId: string, enabled: boolean = true) {
  const { isPending, error, data } = useQuery({
    queryKey: ["racks", nurseryId, tankId],
    queryFn: () => API.getRacks(nurseryId, tankId),
    enabled
  });

  return {
    isPending,
    error,
    data,
  };
}

export default useRacks;
